/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { scroller } from 'react-scroll';

import { Accordion, AccordionHeader, AccordionPanel, Link } from '@coursera/cds-core';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import type { Props } from 'bundles/tutorials/components/TableOfContents';

const styles = {
  accordionHeader: css`
    button {
      padding-left: 0 !important;
    }
  `,
  headingList: css`
    padding-left: 0;
  `,
  heading: css`
    padding: 4px 0;
    list-style: none;
    color: var(--cds-color-neutral-primary);
  `,
  link: css`
    color: var(--cds-color-neutral-primary);

    &:hover,
    &:visited {
      color: var(--cds-color-neutral-primary) !important;
    }
  `,
};

const MobileTableOfContents = ({ links }: Props) => {
  if (!links.length) {
    return null;
  }

  const handleNavigation = (headingId: string) => {
    scroller.scrollTo(headingId, {
      offset: -70,
      smooth: true,
    });
  };

  return (
    <Accordion variant="silent">
      <AccordionHeader label="On this page" css={styles.accordionHeader} />
      <AccordionPanel>
        <ul css={styles.headingList}>
          {links.map((link) => (
            <li key={link.headingId} css={styles.heading}>
              <Link
                css={styles.link}
                variant="quiet"
                typographyVariant="bodyPrimary"
                href={`#${link.headingId}`}
                component={TrackedA}
                trackingName="mobile_toc_link"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  handleNavigation(link.headingId);
                }}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </AccordionPanel>
    </Accordion>
  );
};

export default MobileTableOfContents;
